module.exports = __webpack_public_path__ + "img/icon_fp_insta.25168c0f.svg";